import * as React from 'react';
import useStaffMembersManagement from '../../hooks/staticQueries/staff/useStaffMembersManagement';
import { StaffMemberManagement } from './staffMemberManagement';
export const StaffMembersManagement = () => {
    const { people } = useStaffMembersManagement();
    return (<>
      {people.map((staffMemeber) => (<StaffMemberManagement staffMember={staffMemeber} key={staffMemeber.name}/>))}
    </>);
};
